import {
  STRUCTURE_TAG_NAMES,
  STRUCTURE_TAG_PLACEHOLDERS,
} from './structureTagNames';

import { getTagElement } from '../utils/getTagElement';

const { REQUIRED, OPTIONAL } = STRUCTURE_TAG_PLACEHOLDERS;
const {
  JOB_TASKS,
  JOB_CATEGORY,
  JOB_POSITION,
  JOB_DEPARTMENT,
  JOB_HIRING_MANAGER,
  JOB_BENEFITS,
  JOB_CLOSING,
  JOB_CURRENCY,
  JOB_SALARY,
  JOB_MINIMUM_EDUCATIONS,
  JOB_EDUCATION,
  JOB_WORK_EXPERIENCE,
  JOB_COUNTRY,
  JOB_SKILLS,
  JOB_SENIORITY,
  JOB_EMPLOYMENT_OPTIONS,
  JOB_LANGUAGE,
  JOB_WORK_SCHEDULE,
  JOB_EMAIL,
  JOB_PHONE_NUMBER,
  JOB_DESCRIPTION,
} = STRUCTURE_TAG_NAMES;

export const REQUIRED_JOB_TAGS = {
  JOB_POSITION: getTagElement(JOB_POSITION, true, 'text', REQUIRED),
  JOB_CATEGORY: getTagElement(JOB_CATEGORY, true, 'text', REQUIRED),
  JOB_TASKS: getTagElement(JOB_TASKS, true, 'text', REQUIRED),
};

export const OPTIONAL_JOB_TAGS = {
  JOB_DEPARTMENT: getTagElement(JOB_DEPARTMENT, false, 'text', OPTIONAL, true),
  JOB_HIRING_MANAGER: getTagElement(
    JOB_HIRING_MANAGER,
    false,
    'text',
    OPTIONAL,
    true,
  ),
  JOB_CLOSING: getTagElement(JOB_CLOSING, false, 'text', OPTIONAL),
  JOB_CURRENCY: getTagElement(JOB_CURRENCY, false, 'text', OPTIONAL),
  JOB_SALARY: getTagElement(JOB_SALARY, false, 'text', OPTIONAL, true),
  JOB_BENEFITS: getTagElement(JOB_BENEFITS, false, 'text', OPTIONAL),
  JOB_MINIMUM_EDUCATIONS: getTagElement(
    JOB_MINIMUM_EDUCATIONS,
    false,
    'text',
    OPTIONAL,
  ),
  JOB_EDUCATION: getTagElement(JOB_EDUCATION, false, 'text', OPTIONAL),
  JOB_WORK_EXPERIENCE: getTagElement(
    JOB_WORK_EXPERIENCE,
    false,
    'text',
    OPTIONAL,
  ),
  JOB_COUNTRY: getTagElement(JOB_COUNTRY, false, 'text', OPTIONAL),
  JOB_SKILLS: getTagElement(JOB_SKILLS, false, 'text', OPTIONAL),
  JOB_SENIORITY: getTagElement(JOB_SENIORITY, false, 'text', OPTIONAL),
  JOB_EMPLOYMENT_OPTIONS: getTagElement(
    JOB_EMPLOYMENT_OPTIONS,
    false,
    'text',
    OPTIONAL,
  ),
  JOB_LANGUAGE: getTagElement(JOB_LANGUAGE, false, 'text', OPTIONAL),
  JOB_WORK_SCHEDULE: getTagElement(JOB_WORK_SCHEDULE, false, 'text', OPTIONAL),
  JOB_EMAIL: getTagElement(JOB_EMAIL, false, 'email', OPTIONAL),
  JOB_PHONE_NUMBER: getTagElement(JOB_PHONE_NUMBER, false, 'tel', OPTIONAL),
  JOB_DESCRIPTION: getTagElement(JOB_DESCRIPTION, false, 'text', OPTIONAL),
};

export const JOB_TAGS = {
  ...REQUIRED_JOB_TAGS,
  ...OPTIONAL_JOB_TAGS,
};
